export default __webpack_public_path__ + "d8f67ae9d3519ff8c381cb723bbb9b9c.png";